import { Box, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import { useAdjustmentStatusContext } from '../../../../Utils/providers/AdjustmentStatusProvider'

const steps = [
  {
    key: 'requiredAdjustments',
    label: 'Primary Faults',
  },
  {
    key: 'secondaryAdjustments',
    label: 'Secondary Faults',
  },
  {
    key: 'vehicleDamage',
    label: 'Vehicle Damage',
  },
  {
    key: 'faultAdjustments',
    label: 'Vehicle Faults',
  },
]

const AdjustmentStatusPanel = () => {
  const { missingSections } = useAdjustmentStatusContext()

  // Hide until initial load complete
  if (Object.keys(missingSections).length === 0) return null

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4 }}>
        {steps.map((step) => {
          const isMissing = missingSections?.[step.key] === true
          const isComplete = missingSections?.[step.key] === false

          return (
            <Box
              key={step.key}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
              }}
            >
              {isComplete && (
                <CheckCircleIcon color="success" fontSize="large" />
              )}
              {isMissing && <ErrorIcon color="warning" fontSize="large" />}
              <Typography variant="caption" fontWeight="bold">
                {step.label}
              </Typography>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default AdjustmentStatusPanel
